import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ShippingItemListType} from "../../../api/apiTypes";

const ShippingsTooltip = ({
                            shippings,
                          }: {
  shippings?: ShippingItemListType[];
}) => {
  const {t} = useTranslation("shipping");
  const filtered = useMemo(() => {
    const filtered: {
      status: string;
      count: number;
      complete?: boolean;
    }[] = [];
    if (shippings && shippings.length > 4) {
      shippings.forEach((s) => {
        const contain = filtered.filter((f) => f.status === s.status);
        if (contain.length > 0) {
          contain[0].count++;
        }
        else {
          filtered.push({status: s.status, count: 1, complete: s.complete});
        }
      });
    }
    return filtered;
  }, [shippings]);
  
  if (shippings && shippings.length > 4) {
    return (<div className={"content"}>
      {filtered.map((s, i) => (<div key={"shippinginfo" + i} className={"row"}>
        <span>{s.count}</span>
        <div className={"right"}>
          <div
            className={"dot " + s.complete}
          />
          {t(s.status)}
        </div>
      </div>))}
    </div>);
  }
  if (shippings && shippings.length) {
    return (<div className={"content"}>
      {shippings && shippings.map((s, i) => (<div key={"shippinginfo" + i} className={"row"}>
        <span>{s.tracking_number}</span>
        <div className={"right"}>
          <div
            className={"dot " + s.complete}
          />
          {t(s.status)}
        </div>
      </div>))}
    </div>);
  }
  
  return null;
};

export default ShippingsTooltip;
